export const COLOR_HEX = {
  Black: "#111318",
  White: "#f5f5f5",
  "Heather Grey": "#9ca3af",
  "Forest Green": "#2f5d3a",
  "Vintage Navy": "#23324d",
  Crimson: "#9b1c2e",
};

// Resolve a swatch colour for any colour name: known preset -> a valid CSS colour keyword -> deterministic hashed fallback.
const CSS_COLOR_KEYWORDS = new Set(["red", "green", "blue", "yellow", "orange", "purple", "pink", "brown", "gray", "grey", "black", "white", "cyan", "magenta", "lime", "teal", "navy", "maroon", "olive", "silver", "gold", "beige", "tan", "coral", "salmon", "khaki", "indigo", "violet", "turquoise", "crimson", "chocolate", "tomato", "orchid"]);

export function colorSwatch(name) {
  if (!name) return "#6b7280";
  if (COLOR_HEX[name]) return COLOR_HEX[name];
  const key = name.trim().toLowerCase();
  if (CSS_COLOR_KEYWORDS.has(key)) return key;
  let h = 0;
  for (let i = 0; i < name.length; i += 1) h = (h * 31 + name.charCodeAt(i)) % 360;
  return `hsl(${h}, 45%, 55%)`;
}

export const TAGS = ["All", "Streetwear", "Vintage", "Cyberpunk", "Typography", "Mascot", "Minimal"];
